import React from "react";
import PropTypes from "prop-types";
import Image from "../image/Image";
import * as classes from "./ContactCard.module.css";

const ContactCard = ({ image = "default", name, job, contact = null }) => {
  return (
    <div className={classes.contactCard}>
      <div className={classes.contactWraper}>
        <Image image={image} contact />
        <div className={classes.contactContent}>
          <h2>{name}</h2>
          <h2>{job}</h2>
          <div className={classes.contactInfo}>
            {contact ? (
              <>
                {contact.email && (
                  <a href={`mailto:${contact.email}`}>{contact.email}</a>
                )}
                {contact.phone && (
                  <a href={`tel:${contact.phone}`}>{contact.phone}</a>
                )}
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

ContactCard.propTypes = {
  image: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  job: PropTypes.string.isRequired,
  contact: PropTypes.object
};

export default ContactCard;
